import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Modal, Icon, IconTypes } from '@app/ui'
import { ModalType } from '@app/types'

interface ErrorModalProps {
  open: boolean
  onClose: () => void
  title: string
  description?: string
  bottomContent?: ReactNode
}

const ErrorModal: FC<ErrorModalProps> = ({
  open,
  onClose,
  title,
  description,
  bottomContent,
}) => {
  return (
    <StyledModal open={open} type={ModalType.standard} onClose={onClose}>
      <ModalContent>
        <IconWrapper>
          <Icon type={IconTypes.cancelCircleIcon} width={50} height={50} />
        </IconWrapper>

        <Title>{title}</Title>
        {description && <Description>{description}</Description>}

        {bottomContent && <BottomContent>{bottomContent}</BottomContent>}
      </ModalContent>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  z-index: 10001 !important;

  .type-standard {
    background: linear-gradient(180deg, rgba(24, 24, 27, 0.95) 0%, rgba(24, 24, 27, 0.98) 100%);
    border: 1px solid rgba(101, 43, 43, 0.3);
    border-radius: 16px;
    max-width: 400px;
    margin: 0 16px;
    padding: 0 !important;

    [data-theme="light"] & {
      background: var(--modal-background);
      border: 1px solid var(--border-primary);
    }
  }

  .modal-content {
    padding: 0;
    padding: 0 !important;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px 12px 12px;
  background: radial-gradient(ellipse 50% 45% at 50% 0%, #652B2B 0%, transparent 100%);

  [data-theme="light"] & {
    background: none;
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 35px;
`

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 4px;
`

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--text-tertiary);
  text-align: center;
  line-height: 1.5;
  margin-bottom: 24px;
`

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export default ErrorModal
